// Shared address validation utilities
export const sanitizeInput = (input: string): string => {
  return input
    .replace(/[<>'";&\\/*+={}[\]()|~`!]/g, '')
    .replace(/\s+/g, ' ') // Normalize multiple spaces to single space
    .slice(0, 200);
};

export const validateAddress = (address: string): boolean => {
  // Must contain at least one letter and one number (house number)
  const hasLetter = /[a-zA-ZšđčćžŠĐČĆŽ]/.test(address);
  const hasNumber = /\d/.test(address);
  const minLength = address.length >= 5;
  const maxLength = address.length <= 100;
  
  return hasLetter && hasNumber && minLength && maxLength;
};

export const hasHouseNumber = (address: string): boolean => {
  return /\d/.test(address);
};